import React, { useEffect, useState } from 'react';
import { Image, Space, Tag, List, Divider, Tooltip, Button } from 'antd';
import ProList from '@ant-design/pro-list';
import { RollbackOutlined } from '@ant-design/icons';
import { dayFormat } from '@/utils/utils';
import styles from './common.less';
import { wxSendChatMessage } from '@/utils/utils';
import { sendMiniLink } from '@/services/wechat';

const PlanPage = (props) => {
  const {
    dispatch,
    report: { planDetailInfo, baseData, classStatusList },
  } = props;
  const { weekNo, planDetailList } = planDetailInfo;

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  useEffect(() => {
    if (planDetailList.length > 0) {
      // 默认展开第一行
      setExpandedRowKeys([planDetailList[0].id]);
    }
  }, []);

  const statusRender = (id) => {
    return classStatusList[id];
  };

  //用户发送评分
  const handleSendScoreClick = async (value) => {
    const { code, msg, data } = await sendMiniLink({
      type: 4,
    });

    if (code === '00000') {
      wxSendChatMessage({
        title: data.content,
        imgUrl: data.imageUrls[0],
        page: `/packageG/pages/score/index.html?courseId=${value.courseId}`, //文本内容
      });
    } else {
      message.error(msg);
    }
  };

  return (
    <div className={styles.reportPage}>
      <div
        style={{ textAlign: 'right' }}
        onClick={() => {
          dispatch({
            type: 'report/changePage',
            payload: {
              page: 0,
            },
          });
        }}
      >
        <Tag color="#2db7f5">
          <RollbackOutlined />
        </Tag>
      </div>
      <header className={styles.header}>
        <Image
          style={{ borderRadius: '50%' }}
          width={80}
          preview={false}
          src={baseData.url}
        />
        <span className={styles.title}>
          {baseData.name}的专属运动计划
          <br />第{weekNo}周
        </span>
      </header>
      <div className={styles.planListWrap}>
        <ProList
          rowKey="id"
          split={true}
          // headerTitle={`${baseData.name}的第${weekNo}周专属运动计划`}
          expandable={{
            expandedRowKeys,
            onExpandedRowsChange: setExpandedRowKeys,
          }}
          dataSource={planDetailList}
          showActions="hover"
          showExtra="hover"
          metas={{
            title: {
              dataIndex: 'courseName',
            },
            subTitle: {
              render: (i, r) => {
                return (
                  <Space size={0}>
                    教练：
                    <Tag color="blue">
                      {r.coachName ? JSON.parse(r.coachName)?.nickName : ''}
                    </Tag>
                    状态：
                    <Tag color="#5BD8A6">{statusRender(r.courseStatus)}</Tag>
                    {/* 1:未完课 2:完课未打分 3:完课已打分 */}
                    {r.rpeState == 2 ? (
                      <Button
                        type="link"
                        onClick={() => {
                          handleSendScoreClick(r);
                        }}
                      >
                        {' '}
                        发送用户评分
                      </Button>
                    ) : (
                      ''
                    )}
                  </Space>
                );
              },
            },
            description: {
              render: (i, r) => {
                return (
                  <div>
                    <div style={{ marginBottom: 10 }}>
                      <span>上课时间：</span>
                      <br />
                      <span>
                        {dayFormat(r.startTime, 'YYYY/MM/DD HH:mm:ss')}
                      </span>
                      {r.startTime ? '-' : ''}
                      <span>{dayFormat(r.endTime, 'YYYY/MM/DD HH:mm:ss')}</span>
                    </div>
                    <div>
                      {r.baseTrainingPhases.map((sub) => (
                        <div>
                          <Divider orientation="left">
                            <div style={{ fontWeight: 'bold' }}>
                              {sub.phaseName}
                            </div>
                          </Divider>
                          <List
                            style={{ marginBottom: 10 }}
                            bordered
                            dataSource={sub.baseHealthPlanSnapshots}
                            renderItem={(subItem) => (
                              <List.Item
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-around',
                                }}
                              >
                                <div
                                  style={{
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    width: '65%',
                                    paddingLeft: '5%',
                                  }}
                                >
                                  <Tooltip title={subItem.actionName}>
                                    {subItem.actionName}
                                  </Tooltip>
                                </div>
                                <div
                                  style={{
                                    width: '30%',
                                  }}
                                >
                                  <Tag color="#2db7f5">
                                    {subItem.actionGroup}
                                  </Tag>
                                </div>
                              </List.Item>
                            )}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                );
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default PlanPage;
